import { convertBoolApiToFormValue, type MaterialProductComponentValue, MaterialProductValueType } from 'api';
import { MaterialComponentValueType } from 'features';

export const convertMaterialProductComponentAPIToMaterialComponentField = (
  materialProductComponentValues: MaterialProductComponentValue[],
  type: MaterialProductValueType
): MaterialComponentValueType[] => {
  return (materialProductComponentValues || [])
    .filter((materialComponentValue) => materialComponentValue.type === type)
    .map((materialComponentValue) => ({
      allowed_value_type: materialComponentValue.supported_component.allowed_value_type,
      boolean_value: convertBoolApiToFormValue(materialComponentValue.boolean_value),
      max_value: materialComponentValue.max_value ? Number(materialComponentValue.max_value) : undefined,
      min_value: materialComponentValue.min_value ? Number(materialComponentValue.min_value) : undefined,
      supported_component_id: materialComponentValue.supported_component.id,
      unit: materialComponentValue.supported_component.component.unit,
    }));
};
